module.exports = __webpack_public_path__ + "static/media/River.829afab9.jpg";